import { CompetitionResult } from "../interfaces/ICompetitions";
import { createContext, ReactNode, useContext } from "react";
import { useCompetition } from "../hooks/useCompetition";
import { useParams } from "react-router-dom";

interface CompetitionContextType {
  competition: CompetitionResult | null;
  loading: boolean;
  error: string | null;
  refreshCompetition: () => Promise<void>;
}

const CompetitionContext = createContext<CompetitionContextType | undefined>(undefined);

export const useCompetitionContext = (): CompetitionContextType => {
  const context = useContext(CompetitionContext);
  if (context === undefined) {
    throw new Error("useCompetitionContext must be used within a CompetitionContextProvider");
  }
  return context;
};

interface CompetitionContextProviderProps {
  children: ReactNode;
}

export const CompetitionContextProvider = ({ children }: CompetitionContextProviderProps) => {
  const { competitionId } = useParams<{ competitionId: string }>();
  const competitionData = useCompetition(competitionId);

  return (
    <CompetitionContext.Provider value={competitionData}>{children}</CompetitionContext.Provider>
  );
};
